module.exports = __webpack_public_path__ + "img/journal_file_add.b1755206.svg";